<template>
    <lander-layout :user="$page.props.user" :racingstars="$page.props.racingstars">
        <div class="bg-gray-800 flex items-center justify-center">
            <div class="flex h-screen max-w-7xl text-center items-center">
			    <div class="h-screen sm:h-3/4 px-6 py-20 sm:py-0 text-white bg-gray-900 bg-primary-cta bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out rounded border shadow-lg grid grid-cols-2" :class="[$page.props.settings.site_name == 'Racing League' ? 'border-racing-league-red' : 'border-racing-stars-yellow']">
					<div class="col-start-1 lg:col-start-2 col-span-2 bg-gray-800 text-gray-900 relative transition duration-500 ease-in-out m-8 sm:m-20 p-8 rounded-md shadow-lg">
						<div class="bg-gray-800 flex flex-col">
							<!-- <application-logo class="col-span-2 lg:col-span-1 mb-4 bg-gray-800 p-4 rounded shadow-md"/> -->
							<div v-if="$page.props.settings.site_name == 'Racing League'" class="rounded-full absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 p-2 bg-racing-league-red text-white transition duration-500 ease-in-out">
								<img class="w-8 h-8 my-auto" :src="asset('images/racingleague/rl.ico')" />
							</div>
							<racing-stars-icon v-else class="rounded-full absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 p-2 bg-racing-stars-yellow text-white transition duration-500 ease-in-out" />
							<h1 class="fold:text-2xl text-3xl font-extrabold tracking-tight sm:text-4xl text-white">
								<span class="block">Ready to Get Competitive?</span>
							</h1>
							<h2 class="text-1xl mt-4 tracking-tight sm:text-2xl" :class="[$page.props.settings.site_name == 'Racing League' ? 'text-white' : 'text-racing-stars-yellow']">
								<span class="block">{{ league.user.first_name }} has invited you to join their league, {{ league.name }}. To get started, either login or create an account.</span>
							</h2>
							<div class="mt-8 flex justify-center">
								<div class="inline-flex rounded-md shadow">
		                        <Link method="get" :href="route('register', { code: league.code })" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md hover:bg-opacity-50" :class="[$page.props.settings.site_name == 'Racing League' ? 'bg-racing-league-red text-white' : 'bg-racing-stars-yellow text-gray-800']">
		                            Register
		                        </Link>
		                    </div>
		                    <div class="ml-3 inline-flex">
								<Link method="get" :href="route('login', { code: league.code })" class="inline-flex items-center justify-center px-5 py-3 border text-base font-medium rounded-md bg-transparent" :class="[$page.props.settings.site_name == 'Racing League' ? 'border-racing-league-red text-racing-league-red  hover:bg-racing-league-red/50 hover:text-white' : 'border-racing-stars-yellow text-racing-stars-yellow  hover:bg-racing-stars-yellow hover:text-gray-800']">
		                            Login
		                        </Link>
		                    </div>
		                </div>
					</div>
				</div>
		        </div>
            </div>
        </div>
    </lander-layout>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import LanderLayout from '@/Layouts/LanderLayout.vue'
import TwCard from '@/Global/Elements/TwCard'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import ApplicationLogo from '@/Jetstream/ApplicationLogo'

export default {
    props: {
        league: Object,
    },
    components: {
        LanderLayout,
        TwCard,
        RacingStarsIcon,
        ApplicationLogo,
        Link,
    }
}

</script>
